module.exports = __webpack_public_path__ + "img/banner_500k.6380d084.jpg";